export default __webpack_public_path__ + "images/knowledge-area-background.svg";